// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  signUp: path(ROOTS_AUTH, "/sign-up"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    report: path(ROOTS_DASHBOARD, "/report"),
  },

  departments: {
    root: path(ROOTS_DASHBOARD, "/hrm/departments"),
    new: path(ROOTS_DASHBOARD, "/hrm/departments/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/hrm/departments/${id}/edit`),
  },
  hrm: { root: path(ROOTS_DASHBOARD, "/hrm") },
  // Keep these internal aliases so shared Staff form navigation stays compatible.
  desigination: {
    root: path(ROOTS_DASHBOARD, "/hrm/roles-and-permissions"),
    new: path(ROOTS_DASHBOARD, "/hrm/roles-and-permissions/new"),
    view: (id) => path(ROOTS_DASHBOARD, `/hrm/roles-and-permissions/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/hrm/roles-and-permissions/${id}/edit`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, "/hrm/staff"),
    new: path(ROOTS_DASHBOARD, "/hrm/staff/new"),
    list: path(ROOTS_DASHBOARD, "/hrm/staff"),
    account: path(ROOTS_DASHBOARD, "/hrm/staff"),
    view: (id) => path(ROOTS_DASHBOARD, `/hrm/staff/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/hrm/staff/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/hrm/staff/${id}/replicate`),
  },
  menu: {
    list: path(ROOTS_DASHBOARD, "/menu/list"),
    newCategory: path(ROOTS_DASHBOARD, "/category/new"),
    newItem: path(ROOTS_DASHBOARD, "/item/new"),
    display: path(ROOTS_DASHBOARD, "/menu/display"),
  },
    item: {
    new: path(ROOTS_DASHBOARD, "/item/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/item/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/item/${id}/replicate`),
  },
  category: {
    new: path(ROOTS_DASHBOARD, "/category/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/category/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/category/${id}/replicate`),
  },

  catalog: {
    categories: {
      list: path(ROOTS_DASHBOARD, "/catalog/categories/list"),
      new: path(ROOTS_DASHBOARD, "/catalog/categories/new"),
      edit: (id) => path(ROOTS_DASHBOARD, `/catalog/categories/${id}/edit`),
    },
    products: {
      list: path(ROOTS_DASHBOARD, "/catalog/products/list"),
      new: path(ROOTS_DASHBOARD, "/catalog/products/new"),
      edit: (id) => path(ROOTS_DASHBOARD, `/catalog/products/${id}/edit`),
    },
    choiceGroups: {
      list: path(ROOTS_DASHBOARD, "/catalog/choice-groups/list"),
      new: path(ROOTS_DASHBOARD, "/catalog/choice-groups/new"),
      edit: (id) => path(ROOTS_DASHBOARD, `/catalog/choice-groups/${id}/edit`),
    },
    boms: {
      list: path(ROOTS_DASHBOARD, "/catalog/bom/list"),
      new: path(ROOTS_DASHBOARD, "/catalog/bom/new"),
      edit: (id) => path(ROOTS_DASHBOARD, `/catalog/bom/${id}/edit`),
    },
  },


  customer: {
    list: path(ROOTS_DASHBOARD, "/customer/list"),
    new: path(ROOTS_DASHBOARD, "/customer/new"),
    account: path(ROOTS_DASHBOARD, "/customer/account"),
    edit: (id) => path(ROOTS_DASHBOARD, `/customer/${id}/edit`),
    profile: (id) => path(ROOTS_DASHBOARD, `/customer/${id}/profile`),
  },

  venues: {
    list: path(ROOTS_DASHBOARD, "/venues/list"),
    new: path(ROOTS_DASHBOARD, "/venues/new"),
    detail: (id) => path(ROOTS_DASHBOARD, `/venues/${id}/detail`),
    edit: (id) => path(ROOTS_DASHBOARD, `/venues/${id}/edit`),
  },

  warehouses: {
    list: path(ROOTS_DASHBOARD, "/warehouses/list"),
    new: path(ROOTS_DASHBOARD, "/warehouses/new"),
    detail: (id) => path(ROOTS_DASHBOARD, `/warehouses/${id}/detail`),
    edit: (id) => path(ROOTS_DASHBOARD, `/warehouses/${id}/edit`),
  },

  subscriptions: {
    list: path(ROOTS_DASHBOARD, "/subscriptions/list"),
    detail: (id) => path(ROOTS_DASHBOARD, `/subscriptions/${id}/detail`),
  },

  store: {
    themeList: path(ROOTS_DASHBOARD, "/store/themes"),
    new: path(ROOTS_DASHBOARD, "/store/new"),
    themePreview: (themeName) => path(ROOTS_DASHBOARD, `/store/themes/Preview/${themeName}`),
    elementditTheme: (themeName) => path(ROOTS_DASHBOARD, `/store/themes/${themeName}/edit`),
  },
  page: {
    list: path(ROOTS_DASHBOARD, "/page/list"),
    new: path(ROOTS_DASHBOARD, "/page/new"),
    account: path(ROOTS_DASHBOARD, "/page/account"),
    edit: (id) => path(ROOTS_DASHBOARD, `/page/${id}/edit`),
    profile: (id) => path(ROOTS_DASHBOARD, `/page/${id}/profile`),
  },

  accounting: {
    root: path(ROOTS_DASHBOARD, "/accounting"),
    list: path(ROOTS_DASHBOARD, "/accounting/accounts/list"),
    journals: path(ROOTS_DASHBOARD, "/accounting/journals/list"),
    journalNew: path(ROOTS_DASHBOARD, "/accounting/journals/new"),
    journalEdit: (id) => path(ROOTS_DASHBOARD, `/accounting/journals/${id}/edit`),
    journalDetail: (id) => path(ROOTS_DASHBOARD, `/accounting/journals/${id}/detail`),
    settings: path(ROOTS_DASHBOARD, "/accounting/settings"),
    new: path(ROOTS_DASHBOARD, "/accounting/accounts/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/accounting/accounts/${id}/edit`),
  },

  businessPartner: {
    root: path(ROOTS_DASHBOARD, "/business-partner"),
    vendorList: path(ROOTS_DASHBOARD, "/business-partner/vendors/list"),
    vendorNew: path(ROOTS_DASHBOARD, "/business-partner/vendors/new"),
    vendorEdit: (id) => path(ROOTS_DASHBOARD, `/business-partner/vendors/${id}/edit`),
    vendorDetail: (id) => path(ROOTS_DASHBOARD, `/business-partner/vendors/${id}/detail`),
    customerList: path(ROOTS_DASHBOARD, "/business-partner/customers/list"),
    customerNew: path(ROOTS_DASHBOARD, "/business-partner/customers/new"),
    customerEdit: (id) => path(ROOTS_DASHBOARD, `/business-partner/customers/${id}/edit`),
    customerDetail: (id) => path(ROOTS_DASHBOARD, `/business-partner/customers/${id}/detail`),
  },

  promotion: {
    list: path(ROOTS_DASHBOARD, "/promotions/list"),
    new: path(ROOTS_DASHBOARD, "/promotions/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/promotions/${id}/edit`),
  },

  integrations: {
    root: path(ROOTS_DASHBOARD, "/integrations"),
  },

  settings: {
    list: path(ROOTS_DASHBOARD, "/settings/list"),
    new: path(ROOTS_DASHBOARD, "/settings/new"),
    general: path(ROOTS_DASHBOARD, "/settings/general"),
    localization: path(ROOTS_DASHBOARD, "/settings/localization"),
    account: path(ROOTS_DASHBOARD, "/settings/account"),
    kds: path(ROOTS_DASHBOARD, "/settings/kds"),
    edit: (id) => path(ROOTS_DASHBOARD, `/settings/${id}/edit`),
  },
};

export const PATH_DOCS = {
  root: "https://docs.minimals.cc",
  changelog: "https://docs.minimals.cc/changelog",
};

export const PATH_ZONE_ON_STORE = "https://mui.com/store/items/zone-landing-page/";

export const PATH_MINIMAL_ON_STORE = "https://mui.com/store/items/minimal-dashboard/";

export const PATH_FREE_VERSION = "https://mui.com/store/items/minimal-dashboard-free/";

export const PATH_FIGMA_PREVIEW =
  "https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1";
